import { __read } from "tslib";
import createElement from '../utils/createElement';
import getDelimiterFromElement from './getDelimiterFromElement';
var ZERO_WIDTH_SPACE = '\u200B';
/**
 * Adds delimiters to the element provided. If the delimiters already exists, will not be added
 * @param node the node to add the delimiters
 */
export default function addDelimiters(node) {
    var _a = __read(getDelimiters(node), 2), delimiterAfter = _a[0], delimiterBefore = _a[1];
    if (!delimiterAfter) {
        delimiterAfter = addDelimiterAfter(node);
    }
    if (!delimiterBefore) {
        delimiterBefore = addDelimiterBefore(node);
    }
    return [delimiterAfter, delimiterBefore];
}
/**
 * Adds delimiter after the element provided.
 * @param element element to use
 */
export function addDelimiterAfter(element) {
    return insertDelimiter(element, "entityDelimiterAfter" /* DELIMITER_AFTER */);
}
/**
 * Adds delimiter before the element provided.
 * @param element element to use
 */
export function addDelimiterBefore(element) {
    return insertDelimiter(element, "entityDelimiterBefore" /* DELIMITER_BEFORE */);
}
function getDelimiters(entityWrapper) {
    var result = [];
    var nextElementSibling = entityWrapper.nextElementSibling, previousElementSibling = entityWrapper.previousElementSibling;
    result.push(isDelimiter(nextElementSibling, "entityDelimiterAfter" /* DELIMITER_AFTER */), isDelimiter(previousElementSibling, "entityDelimiterBefore" /* DELIMITER_BEFORE */));
    return result;
}
function isDelimiter(el, className) {
    return el && getDelimiterFromElement(el) && el.classList.contains(className) ? el : undefined;
}
function insertDelimiter(element, delimiterClass) {
    var span = createElement({
        tag: 'span',
        className: delimiterClass,
        children: [ZERO_WIDTH_SPACE],
    }, element.ownerDocument);
    if (span) {
        var insertPosition = delimiterClass == "entityDelimiterAfter" /* DELIMITER_AFTER */ ? 'afterend' : 'beforebegin';
        element.insertAdjacentElement(insertPosition, span);
    }
    return span;
}
//# sourceMappingURL=addDelimiters.js.map